(function() {
    'use strict';

    angular
        .module('sodDocumentLibrary')
        .filter('documentLibraryImage', documentLibraryImage);

    function documentLibraryImage($sce) {
        return function(item) { 
            if (item.item_type === 'folder') {
                return '<div class="item-icon"><i class="fa fa-2x fa-sod-folder"></i></div>';
            }
            if (['jpg','gif', 'jpeg', 'tiff', 'png', 'svg'].indexOf(item.extension) >= 0) {
                return $sce.trustAsHtml('<div class="item-image" style="background-image:url(' + item.url + ')"></div>');
            } else {
                return '<div class="item-icon"><i class="fa fa-2x ' + item.icon + '"></i></div>';
            }
        };
    }
})();